import { memo } from 'react'
import { openContactSupportDrawer } from '../../../state/modals/state.drawer'
import i18n from '../../../utilities/i18n'
import Link from '../Link'

export const GenericErrorComponent = () => {
    return (
        <p>
            {i18n.t('error.description.intro')}{' '}
            <Link
                onClick={openContactSupportDrawer}
                title="Contact Support"
                actionLink
                underline
                thin
                mfc
            >
                {i18n.t('error.description.contact')}
            </Link>{' '}
            {i18n.t('error.description.finish')}
        </p>
    )
}

export default memo(GenericErrorComponent)
